<template>
  <div
    id="port-master-navigation"
    v-on:blur="open = false"
    tabindex="0"
    v-if="!disableNavigation && hasAddonGkmgPortMaster"
  >
    <div
      class="select-menu-button"
      :class="{ 'button-open': open }"
      color="#2D9CDB"
      @click="open = !open"
    >
      <div class="button-inner" v-if="isEnterpriseMenu">
        <feather-icon
          class="settings-icon"
          icon="SettingsIcon"
          svgClasses="h-4 w-4"
        />
        <span class="menu-title">入出港管理メニュー</span>
        <feather-icon
          class="arrow-icon"
          :class="{ open: open }"
          icon="ChevronDownIcon"
          svgClasses="h-4 w-4"
        />
      </div>
      <div class="button-inner" v-else>
        <feather-icon
          class="anchor-icon"
          icon="AnchorIcon"
          svgClasses="h-4 w-4"
        />
        <span class="menu-title">{{ selectedPort.name }}メニュー</span>
        <feather-icon
          class="arrow-icon"
          :class="{ open: open }"
          icon="ChevronDownIcon"
          svgClasses="h-4 w-4"
        />
      </div>
    </div>
    <transition name="fade">
      <template v-if="isEnterpriseMenu">
        <div class="select-item-container vx-card" v-if="open">
          <div
            class="select-item"
            @click="linkTo(enterpriseOption.path)"
            v-for="(enterpriseOption, index) in filteredEnterpriseOptions"
            :key="index"
          >
            {{ enterpriseOption.name }}
          </div>
        </div>
      </template>
      <template v-else>
        <div class="select-item-container vx-card" v-if="open">
          <div
            class="select-item"
            @click="linkTo(portOption.path)"
            v-for="(portOption, index) in filteredPortOptions"
            :key="index"
          >
            {{ portOption.name }}
          </div>
        </div>
      </template>
    </transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState, mapGetters } = createNamespacedHelpers("gkmgPortMaster");

export default {
  data() {
    return {
      open: false,
    };
  },
  computed: {
    ...mapGetters(["gkmgPortMasterAuth", "hasAddonGkmgPortMaster"]),
    ...mapState({
      selectedPort: (state) => state.selectedPort,
      enterpriseMenuItems: (state) => state.enterpriseMenuItems,
      enterprisePortMenuItems: (state) => state.enterprisePortMenuItems,
    }),
    filteredPortOptions() {
      let portOptions = [
        {
          name: "入出港管理",
          path: "addon-gkmg-port-master-port-menu",
        },
      ];
      portOptions = portOptions
        .concat(this.enterprisePortMenuItems)
        .filter(({ needUploadCsvPrivilege }) => {
          if (needUploadCsvPrivilege) {
            return this.isShowUploadCsv;
          }
          return true;
        });
      return portOptions.filter((element) => element.path != this.$route.name);
    },
    filteredEnterpriseOptions() {
      let enterpriseOptions = [
        {
          name: "入出港管理",
          path: "addon-gkmg-port-master-port-menu",
        },
      ];
      enterpriseOptions = enterpriseOptions.concat(this.enterpriseMenuItems);
      return enterpriseOptions.filter(
        (element) => element.path != this.$route.name,
      );
    },
    disableNavigation() {
      return this.$route.name == "addon-gkmg-port-master-port-menu";
    },
    isEnterpriseMenu() {
      return this.enterpriseMenuItems
        .map((element) => element.path)
        .includes(this.$route.name);
    },
    isShowUploadCsv() {
      // this.gkmgPortMasterAuthは元はconst.jsのGKMG_AUTH_MASTERを見ているため、必ずPortMenu.uploadCsvを持つ
      return (
        this.hasAddonGkmgPortMaster &&
        this.gkmgPortMasterAuth.PortMenu.uploadCsv
      );
    },
  },
  methods: {
    linkTo(path) {
      this.$router.push({
        name: path,
      });
      this.open = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/port-master/_variables.scss";
#port-master-navigation {
  position: relative;
  width: fit-content;
  margin-left: auto;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.select-menu-button {
  margin-top: -10px;
  min-width: 200px;
  border-radius: 6px;
  border: none;
  background: $pm-blue;
  color: $pm-white;
  padding: 10.5px 15px !important;
  transition: all 300ms 0s ease;
  cursor: pointer;
  font-size: 14px;
  &:hover {
    box-shadow: 0 9px 28px -9px $pm-blue;
  }
}
.button-open {
  border-radius: 4px 4px 0px 0px;
}
.menu-title {
  margin-right: 10px;
}
.vx-card {
  width: fit-content;
  overflow: hidden;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
.anchor-icon,
.settings-icon {
  margin-right: 5px;
  padding-bottom: 2px;
}
.select-item-container {
  position: absolute;
  z-index: 1;
  background: white;
  width: 100%;
}
.select-item {
  cursor: pointer;
  padding: 10.5px 15px;
}
.select-item:hover {
  background: $pm-transparent-blue;
  color: $pm-blue;
  transition: 0.2s;
}
.button-inner {
  display: flex;
  align-items: center;
}
.arrow-icon {
  margin-left: auto;
  transition: all 300ms 0s ease;
}
.open {
  transform: rotateZ(-180deg);
}
.vs-button-text {
  display: block !important;
}
</style>
